// Odoo 348733 (фаза 2, MVP): выбор движка графа ОПЦИЕЙ виджета — без опции рендерится прежний AttrGraph (sigma). В AttrGraph.vue — только
// две строки: кнопка <GraphEngineToggle> в островках графа (шестерёнки и командной панели); без сетевого режима и без движка в записи она
// не рисует ничего, код самого графа не менялся. Опция: doc.viewParams.<имя attr графа>.graphEngine = 'lens' в записи виджета (для графа DataHub — запись
// widget-DS-Graph-DataHub, attr dataGraph). store.get_viewParam читает и запасные места: строку fieldsMapping с binding
// 'viewParams.dataGraph.graphEngine' и параметр самого attr (вид сегмента WIDGET-DS общий для ВСЕХ DS-графов — туда не ставить).
//
// Odoo 348733 (переключатель, поручение Андрея «по опции встроить движок»): пользователь сам выбирает движок кнопкой «Classic / Lens»
// (GraphEngineToggle.vue — островок нижнего правого угла графа, в обоих движках). Где кнопка есть: граф в СЕТЕВОМ режиме
// (doc.params.graph_network = true — его ставит только граф DataHub) или граф, у записи которого движок уже задан (опция MVP), — и
// никогда на графе с полосами (каскад, граф структуры записи: прямоугольники graphContext с заголовком и без якоря), их линза не рисует.
// Выбор пишется в viewParams графа (graphEngine: 'lens' | 'sigma') БЕЗ пометки записи изменённой — как смена вкладки таблица ↔ граф
// (память WIDGET._activeTabByPanel) и чипсы стола (снимок chipsKeep в localStorage) — и запоминается для пользователя в localStorage
// (ключ как у chipsKeep_key: пользователь, база, запись виджета, attr) — переживает перезагрузку. Сохранение виджета делает выбор
// умолчанием для всех. Порядок: личный выбор (там, где кнопка есть) → значение записи (viewParams → fieldsMapping → attr) → умолчание
// базы (там, где кнопка есть) → классика.
//
// Odoo 348733 (Андрей, шина #105310: «Граф в датахабе, нужно сделать чтобы по-умолчанию показывал линзу»; графы стендов Игоря остаются
// классикой, #102112): умолчание БАЗЫ — настройка fe.chart.graphEngineDefault записи SETTINGS (форма: Chart defaults), '' | 'lens' | 'sigma'.
// Приезжает с бэка в answer.settings.fe (группа chart) и читается store.setting: override браузера (?fe.… / feSettings.set) → база → ''.
// Пусто (по умолчанию) — как раньше: классика. Запись widget-DS-Graph-DataHub предопределённая (пересев из кода) — потому настройка базы, а не запись
export const LENS_ENGINE = 'lens'
export const CLASSIC_ENGINE = 'sigma'
export const DB_DEFAULT_SETTING = 'fe.chart.graphEngineDefault'
const engineSet = (v) => v === LENS_ENGINE || v === CLASSIC_ENGINE

// граф с полосами-дорожками: прямоугольник graphContext с заголовком и без якоря (каскад, граф структуры записи)
export function graphLanes(dg) {
    const gc = dg && Array.isArray(dg.graphContext) ? dg.graphContext : []
    return gc.some((r) => r && (r.type === 'rect' || r.type === 'fillRect') && !r.anchor && !!r.title)
}

// решение по входам (чистая функция — юнит-тест): network — сетевой режим графа, record — движок в записи ('' — не задан),
// personal — личный выбор ('' — нет), lanes — граф с полосами, dbDefault — умолчание базы ('' — не задано; действует только там,
// где кнопка есть, и после записи — кнопку не добавляет)
export function graphEngine_resolve({ network = false, record = '', personal = '', lanes = false, dbDefault = '' } = {}) {
    const available = !lanes && (network || engineSet(record))
    const engine = (available && engineSet(personal) && personal) || (engineSet(record) && record) || (available && engineSet(dbDefault) && dbDefault) || CLASSIC_ENGINE
    return { available, engine, lens: engine === LENS_ENGINE && !lanes }
}

// умолчание базы для графа с кнопкой: '' | 'lens' | 'sigma' (прочее — ''); без store.setting (юнит, чужой стор) — ''
export function graphEngine_dbDefault(store) {
    try {
        void store._settingsEpoch   // реактивная зависимость: настройки базы переприменены (settings_apply) или override (feSettings.set)
        const v = typeof store.setting === 'function' ? store.setting(DB_DEFAULT_SETTING, '') : ''
        return engineSet(v) ? v : ''
    } catch (e) {
        return ''
    }
}

// ключ личного выбора — как chipsKeep_key стора: пользователь + база, плюс запись виджета и attr графа; без записи — не запоминаем
export function graphEngine_key(store, WIDGET, attr) {
    const w = WIDGET && WIDGET.record && WIDGET.record.id
    if (!w || !attr || !attr.name) return ''
    const u = (store && store.user && (store.user.id || store.user.email)) || 'user'
    const db = (store && store.user && store.user.database && store.user.database.dbid) || ''
    return `graphEngine:${u}:${db}:${w}:${attr.name}`
}
const personalMem = new Map()   // кэш localStorage: AttrTab спрашивает движок на каждой перерисовке
function personal_get(key) {
    if (!key) return ''
    if (!personalMem.has(key)) {
        let v = ''
        try { v = localStorage.getItem(key) || '' } catch (e) { v = '' }   // приватный режим / хранилище закрыто — выбора нет
        personalMem.set(key, v)
    }
    return personalMem.get(key)
}
function personal_set(key, v) {
    if (!key) return
    personalMem.set(key, v)
    try { localStorage.setItem(key, v) } catch (e) { /* хранилище недоступно — выбор живёт до перезагрузки */ }
}

function graphPayload(store, WIDGET, attr) {
    try {
        const [doc, binding] = store.attr_get_link(WIDGET, attr)
        return doc && binding ? doc[binding] : null
    } catch (e) {
        return null
    }
}

export function graphEngine_state(store, WIDGET, attr) {
    if (!attr || attr.attr_type !== 'AttrGraph' || !WIDGET || !WIDGET.record) return { available: false, engine: CLASSIC_ENGINE, lens: false }
    let record = ''
    try { record = store.get_viewParam(WIDGET, attr.name, 'graphEngine', '', attr) } catch (e) { record = '' }
    const network = !!(WIDGET.record.doc && WIDGET.record.doc.params && WIDGET.record.doc.params.graph_network === true)
    // Odoo 348733 (ревью ie-engine7, шина #102266): не сетевой граф без движка в записи (каскад, граф структуры записи, прочие графы) —
    // прежний путь: ни данных графа (graphContext), ни счётчика, ни localStorage не читаем, иначе AttrTab подписывается на данные графа и
    // перерисовывается на каждом опросе каскада / Refresh. Ответ тот же, что дал бы graphEngine_resolve: кнопки нет, движок — классика
    if (!network && record !== LENS_ENGINE && record !== CLASSIC_ENGINE) return { available: false, engine: CLASSIC_ENGINE, lens: false }
    void WIDGET._graphEngineTick   // реактивная зависимость: личный выбор живёт вне записи (localStorage), смену сообщает счётчик на виджете
    const lanes = graphLanes(graphPayload(store, WIDGET, attr))
    return graphEngine_resolve({ network, record, personal: personal_get(graphEngine_key(store, WIDGET, attr)), lanes, dbDefault: graphEngine_dbDefault(store) })
}

export function graphEngine_component(store, WIDGET, attr) {
    const c = attr && attr.component
    if (!attr || attr.attr_type !== 'AttrGraph' || !WIDGET || !WIDGET.record) return c
    try {
        return graphEngine_state(store, WIDGET, attr).lens ? 'AttrGraphLens' : c
    } catch (e) {
        return c
    }
}

// кнопка «Classic / Lens»: viewParams графа без пометки записи изменённой (set_modified = false) + личный выбор; запросов к бэку нет —
// AttrTab перерисовывается и монтирует другой движок на тех же данных стора
export function graphEngine_set(store, WIDGET, attr, engine) {
    const v = engine === LENS_ENGINE ? LENS_ENGINE : CLASSIC_ENGINE
    personal_set(graphEngine_key(store, WIDGET, attr), v)
    store.set_viewParam(WIDGET, attr.name, 'graphEngine', v, attr, false)
    WIDGET._graphEngineTick = (WIDGET._graphEngineTick || 0) + 1
}
